<template>
  <div direction="right" class="default-slider space-top-lg">
    <div class="slider-inner space-top-lg" style="width:55%; z-index: 9;" v-if="!isMetaDataEmpty">
      <div class="slider-header">
        <span>
          {{ selectedEntity.entity_id}}
        </span>
        <div v-if="showRetrigger && selectedEntity.transaction_type === transactionTypes.OUTBOUND">
        <Button
            type="secondary"
            class="btn"
            @click="add()"
            >{{$t('INDENT_RETRIGGER')}}</Button>
        </div>
      </div>
      <div class="slider-body p-0">
        <ElTabs class="tab-default tab-sm tab-bg no-bg">
          <Tab-pane :label="$t('INTEGRATION_DETAILS')">
            <div class="tab-content">
                <div class="flex-container panel-head align-top mb-0">
                  <div v-for="(item, index) in detailsList" :key="index">
                  <div v-for="(option, index) in item" :key="index"
                  class="flex-item">
                      <div v-if ="option.dataType === 'date' && selectedEntity[option.value]">
                        <p v-if="selectedEntity[option.value]" >
                        {{ $t(option.tlabel) }} :
                        <strong>{{$moment(selectedEntity[option.value]).format("DD-MMM-YYYY")}}
                        </strong>
                        </p>
                      </div>
                      <div v-if ="option.dataType === 'string' && selectedEntity[option.value]">
                        <p v-if="selectedEntity[option.value]" >
                        {{ $t(option.tlabel) }} : <strong>{{selectedEntity[option.value]}}</strong>
                        </p>
                      </div>
                  </div>
                </div>
                </div>
            </div>

          </Tab-pane>
        </ElTabs>
        <ElTabs class="tab-default tab-sm tab-bg no-bg">
          <Tab-pane :label="$t('INTEGRATION_PAYLOAD')">
            <div class="tab-content">
              <Row>
                <Col v-if="selectedEntity.transaction_type === transactionTypes.OUTBOUND" :span="10">
                  {{ $t('INTEGRATION_JSON_FILENAME') }} :
                </Col>
                <Col v-if="selectedEntity.transaction_type === transactionTypes.INBOUND" :span="10">
                  {{ $t('INTEGRATION_EXCEL_FILENAME') }} :
                </Col>
                <Col :span="4">
                  <div v-if="selectedEntity.req_s3_url">
                      <Tooltip :open-delay="100" effect="dark" placement="top-end">
                            <i class="action-icon" @click="getPayload()">
                              <a class = 'download-file'></a>
                                <svgicon v-if="selectedEntity.transaction_type === transactionTypes.OUTBOUND" name="icon-json" :original="true"/>
                                <svgicon v-if="selectedEntity.transaction_type === transactionTypes.INBOUND" name="icon-excel" :original="true"/>
                            </i>
                            <div slot="content"
                              v-if="selectedEntity.transaction_type === transactionTypes.OUTBOUND">
                              {{ $t('INTEGRATION_DOWNLOAD_JSON') }}
                            </div>
                            <div slot="content"
                              v-if="selectedEntity.transaction_type === transactionTypes.INBOUND">
                              {{ $t('INTEGRATION_DOWNLOAD_EXCEL') }}
                            </div>
                      </Tooltip>
                      </div>
                      <div v-else>
                        <strong>{{ $t('PAYLOAD_UNAVAILABLE_MSG') }}</strong>
                      </div>
                </Col>
              </Row>
              </div>
          </Tab-pane>
        </ElTabs>
      </div>
    </div>
  </div>
</template>
<script>
import { detailsList,  transactionTypes } from '@/constants/integrations';

export default {
  name: 'entityDetails',
  props: {
    selectedEntity: {
      type: Object,
    },
    columnType: {
      type: Number,
    },
    columnName: {
      type: String,
    },
  },
  data() {
    return {
      detailsList,
      transactionTypes,
    };
  },
  computed: {
    isMetaDataEmpty() {
      if (this.selectedEntity && this.selectedEntity.api_name) return false;
      return true;
    },
    showRetrigger() {
      return (this.selectedEntity.erp_retry_requested || (this.columnName !== ''
      && this.columnName !== 'successfulEntity'));
    },
  },
  methods: {
    async getPayload() {
      let result = '';
      if (this.selectedEntity) {
        const tmsTransactionId = this.selectedEntity.tms_transaction_id;
        result = await this.$store.dispatch('order/getMitmPayload', { tmsTransactionId });
      }
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      }
    },
    async add() {
      if (this.selectedEntity) {
        const data = {
          entity_id: this.selectedEntity.entity_id,
          api_name: this.selectedEntity.api_name,
        };
        const result = await this.$store.dispatch('order/retryRequest', { data });
        if (result.status === 204) {
          this.$successMessage({ message: 'Retriggered successfully. Please check after sometime' });
        } else {
          this.$errorMessage({ message: result.error || 'Retrigger failed. Please try again later' });
        }
      }
    },
  },
};
</script>
<style scoped>
.default-slider .slider-inner.space-top-lg{
  top:248px !important;
}
</style>

